
const initialState = {
  open: false,
  severity: 'success',
  message: '',
};

const SET_NOTIFICATION   = "SET_NOTIFICATION";
const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";

export const actionCreators = {
    showSuccess: (message) => async (dispatch) => {
        dispatch({ type: SET_NOTIFICATION, severity: 'success', message });
    },

    showInfo: (message) => async (dispatch) => {
        dispatch({ type: SET_NOTIFICATION, severity: 'info', message });
    },

    showWarn: (message) => async (dispatch) => {
        dispatch({ type: SET_NOTIFICATION, severity: 'warning', message });
    },

    showError: (message) => async (dispatch) => {
        dispatch({ type: SET_NOTIFICATION, severity: 'error', message });
    },

    closeNotification: () => async (dispatch, getState) => {
        dispatch({ type: CLOSE_NOTIFICATION });
    }
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION:
      return {
        ...state,
        open: true,
        severity: action.severity,
        message: action.message,
      };
    case CLOSE_NOTIFICATION:
      return {
        ...state,
          open: false,
      };
    default:
      return state;
  }
};

